import React from 'react'
import styles from './styles.module.less'
import { getImageSrc } from '@/utils/utils'
export default ({ src }) => (
  <img className={styles.upgrade} alt="网站正在维护" src={getImageSrc(src)} />
)
